/**
 * parseYmdLocal — parse a `YYYY-MM-DD` day string as LOCAL-tz midnight.
 *
 * The backend keys cost points on a bare `day` string (e.g. `2026-07-24`).
 * `new Date('2026-07-24')` parses that as **UTC** midnight, which then renders
 * one calendar day earlier for any viewer west of UTC (D5). This helper builds
 * the Date from local (y, m-1, d) components instead, so the calendar date is
 * preserved regardless of the viewer's timezone — consistent with
 * costTimeRange.ymd(), which already formats dates in local tz.
 *
 * Non-YMD inputs (e.g. a full ISO timestamp) fall through to native parsing.
 */
export function parseYmdLocal(day: string): Date {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (m) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(day);
}

export default parseYmdLocal;
